import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { changeStatus, onFetchPriceListProduct, onSetSelectedPriceListProduct, selectPriceListProductState, setAction } from "../redux/slices/priceListProductSlice"
import { PriceListProductsAPI } from "../apis/PriceListProductsAPI"
import { PriceListProduct } from "../types/slices/priceListProductType"

export const usePriceListProductStore = () => {

    const dispatch = useDispatch()
    const { priceListProduct, priceListSelectedProduct, status, action } = useSelector(selectPriceListProductState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getPriceListProduct = async (data?: object) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await PriceListProductsAPI.getPriceListProduct(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                console.log(response.data.message)
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail } = response.data
            console.log(detail)
            dispatch(onFetchPriceListProduct(detail))
            dispatch(changeStatus(ApiStatus.FETCHED))
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createPriceListProduct = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await PriceListProductsAPI.createPriceListProduct(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const editPriceListProduct = async (idlist: number, data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await PriceListProductsAPI.editPriceListProduct(idlist, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deletePriceListProduct = async (idlist: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await PriceListProductsAPI.deletePriceListProduct(idlist)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedPriceListProduct = (list: PriceListProduct) => {
        try {
            dispatch(onSetSelectedPriceListProduct(list))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionPriceListProduct = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    const deleteDetail = async (id: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await PriceListProductsAPI.deleteDetail(id)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    return {
        //states
        priceListProduct,
        priceListSelectedProduct,
        status,
        action,
        //actions
        getPriceListProduct,
        createPriceListProduct,
        editPriceListProduct,
        deletePriceListProduct,
        setSelectedPriceListProduct,
        setActionPriceListProduct,
        deleteDetail
    }
}